import { MouseEvent, useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IS_SCREENS_MODE } from "../../../../config/appMode";
import UserContext from "../../../../domain/providers/user/UserContext";
import AuthGateModal, { OrigenAcceso } from "./AuthGateModal";

interface Destino {
    to?: string;
    state?: unknown;
    /** Se ejecuta tras iniciar sesión (p. ej. guardar el favorito que se intentó marcar). */
    alExito?: () => void;
}

/**
 * Pide sesión antes de una acción. En modo pantallas nunca la pide.
 * - `guard(e, destino)`: úsalo en el onClick de un Link; si falta sesión cancela la navegación,
 *   abre el modal y, al iniciar sesión, navega a `destino`. Devuelve true si interceptó.
 * - `abrir()`: abre el modal sin destino (p. ej. desde un botón "Inicia sesión").
 * - `modal`: renderízalo FUERA del Link (los clics del portal burbujean por el árbol de React).
 */
export function useRequireAuth(origen: OrigenAcceso, vehiculoId?: string) {
    const { user } = useContext(UserContext);
    const navigate = useNavigate();
    const [abierto, setAbierto] = useState(false);
    const destino = useRef<Destino | undefined>(undefined);

    const requiere = !IS_SCREENS_MODE && !user;

    const guard = (e: MouseEvent, dest?: Destino): boolean => {
        if (!requiere) return false;
        e.preventDefault();
        destino.current = dest;
        setAbierto(true);
        return true;
    };

    const modal = abierto ? (
        <AuthGateModal
            origen={origen}
            vehiculoId={vehiculoId}
            onClose={() => setAbierto(false)}
            onSuccess={() => {
                setAbierto(false);
                destino.current?.alExito?.();
                if (destino.current?.to) navigate(destino.current.to, { state: destino.current.state });
            }}
        />
    ) : null;

    return { requiere, guard, abrir: () => setAbierto(true), modal };
}
